// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"FailedLoginErrorPage_errorPageWrapper__a4N2x","showboatLogo":"FailedLoginErrorPage_showboatLogo__6bhls"};